import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../config";
import { armarFondo } from "../utils/fondoServicio";




const ColorFondoAdmin = ({ setColorFondoGlobal }) => {
  const [color, setColor] = useState("#ffffff"); // color por defecto
  const [difuminado, setDifuminado] = useState(false);
  const [loading, setLoading] = useState(false);

  // Traer el color actual al cargar el componente
  useEffect(() => {
    const cargarColor = async () => {
      try {

const res = await axios.get(`${API_URL}/api/color-fondo`);

        setColor(res.data.fondo_app);
        setDifuminado(!!res.data.fondo_difuminado);
      } catch (error) {
        console.error("Error al obtener color de fondo:", error);
      }
    };
    cargarColor();
  }, []);

  // Guardar el nuevo color
  const guardarColor = async () => {
    try {
      setLoading(true);
await axios.post(`${API_URL}/api/color-fondo`, {
  fondo_app: color,
  fondo_difuminado: difuminado,
});


      setColorFondoGlobal(armarFondo(color, difuminado)); // Actualiza el fondo en toda la app
      alert("🎨 Color de fondo actualizado correctamente!");
    } catch (error) {
      console.error("Error al actualizar color:", error);
      alert("❌ No se pudo actualizar el color");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#f0f4ff",
        padding: "30px",
        borderRadius: "12px",
        maxWidth: "400px",
        margin: "20px auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        textAlign: "center",
      }}
    >
      <h2 style={{ color: "#1e3a8a", marginBottom: "20px" }}>
        Cambiar color de fondo
      </h2>

      <input
        type="color"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        style={{ width: "100px", height: "100px", border: "none", cursor: "pointer" }}
      />

      <input
        type="text"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        style={{
          display: "block",
          margin: "12px auto 0",
          fontFamily: "monospace",
          fontSize: 14,
          padding: "6px 10px",
          borderRadius: 6,
          border: "1px solid #cbd5e1",
          width: 110,
          textAlign: "center",
        }}
      />

      <label
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          marginTop: 14,
          fontSize: 14,
          color: "#475569",
          cursor: "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={difuminado}
          onChange={(e) => setDifuminado(e.target.checked)}
        />
        Difuminado
      </label>

      <div style={{ marginTop: "20px" }}>
        <button
          onClick={guardarColor}
          disabled={loading}
          style={{
            padding: "10px 25px",
            backgroundColor: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {loading ? "Guardando..." : "Guardar color"}
        </button>
      </div>
    </div>
  );
};

export default ColorFondoAdmin;


